import { render } from "./Products.vue?vue&type=template&id=33289274"
import script from "./Products.vue?vue&type=script&lang=js"
export * from "./Products.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Code Backup\\ts-web-old\\TatSingGroup-Web\\ts-trading\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__